<div class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center p-4 animate-fade-in">
    <div [class]="containerClasses" class="w-full max-w-lg p-6 rounded-lg shadow-lg relative flex flex-col items-center sm:items-start">

        <!-- Botão de fechar -->
        <span class="absolute top-3 right-3 text-xl cursor-pointer hover:opacity-80 transition"
            (click)="close.emit()">
            <ui-icon [icon]="EIcon.Close" [color]="EAlert.DARK" [size]="EComponentSize.Medium"></ui-icon>
        </span>

        <!-- Ícone -->
        <ui-icon [icon]="icon()" [size]="EComponentSize.ExtraLarge" [color]="type()" class="mb-3 sm:mb-0"></ui-icon>

        <!-- Conteúdo -->
        <div class="text-center sm:text-left">
            <ui-label [type]="type()" [tag]="ELabelType.SUBTITLE">{{ title() }}</ui-label>
            <ui-label [type]="darkMode ? EAlert.LIGHT : EAlert.DARK" [tag]="ELabelType.PARAGRAPH"
                class="mt-1 text-sm sm:text-base">
                {{ message() }}
            </ui-label>
        </div>

        <!-- Botões -->
        <div class="mt-6 flex w-full justify-center sm:justify-end gap-3">
            <ui-button [text]="'Cancelar'" (action)="cancel.emit()" [size]="EComponentSize.Large"
                [type]="darkMode ? EAlert.LIGHT : EAlert.DARK"></ui-button>
            <ui-button [text]="'Confirmar'" (action)="confirm.emit()" [size]="EComponentSize.Large"
                [type]="type()"></ui-button>
        </div>

    </div>
</div>
